module.exports = __webpack_public_path__ + "img/summary-dex-complete.4b679919.svg";